import React from 'react';
import Logo from '../components/Logo';
import Navigation from '../components/Navigation';

const About = () => {
    return (
        <div>
            <Logo />
            <Navigation />
           <h1>A Propos</h1>
           <br />
           <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex dolorem inventore amet sunt exercitationem aliquam, deleniti earum quae tempora iure placeat, harum cum facilis. Expedita deserunt voluptatum quidem tempora ratione earum qui iusto est exercitationem accusantium. Quos quod incidunt optio fugit, qui rem quis eius omnis laborum quam aspernatur facilis consequuntur blanditiis dolorum! Recusandae quod ducimus ex error autem accusamus dicta, nulla, quisquam odit sed sunt officia animi? Sed, tempore debitis doloribus fuga quos minus maiores odit obcaecati commodi aliquam dolore sit quae fugit cumque recusandae accusantium molestias ipsam. Itaque corrupti odit ipsa possimus, odio perferendis at aut distinctio magnam!</p> 
           <br />
           <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita molestiae cupiditate corrupti nemo voluptates, quis perferendis, cumque et fuga repellendus pariatur, ea aliquid placeat natus. Veniam voluptate eos iste accusantium!</p>
           <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid illum natus modi, vero esse distinctio odio aliquam officiis inventore sequi, itaque veniam voluptates. Esse excepturi laudantium similique vel aspernatur ipsam?</p>
        </div>
    );
};

export default About;